import axios from 'axios'
import * as types from '../mutation-types'

// namespaced
export const namespaced = true

// state
export const state = {
  msg: null,
  banners: []
}

// getters
export const getters = {
  bannerMsg: state => state.msg,
  banners: state => state.banners
}

// mutations
export const mutations = {
  [types.RESET_BANNER_DATA] (state) {
    Object.assign(state, {
      msg: null,
      banners: []
    })
  },

  [types.SET_BANNER_MSG] (state, msg) {
    const msgs = {
      banner: 'Failed to fetch banners'
    }
    state.msg = msg ? (msgs[msg] ? msgs[msg] : msg) : 'Failed to fetch banners'
  },

  [types.RESET_BANNER_MSG] (state) {
    state.msg = null
  },

  [types.FETCH_BANNERS] (state, banners) {
    state.banners = banners
  },

  [types.RESET_BANNERS] (state) {
    state.banners = []
  }
}

// actions
export const actions = {
  resetBannerData ({ commit }) {
    commit(types.RESET_BANNER_DATA)
  },

  async fetchBanners ({ commit, rootGetters }) {
    commit(types.RESET_BANNER_MSG)
    try {
      const { data } = await axios.post('/api/banners', {
        group_id: parseInt(rootGetters['config/gid']),
        restaurant_id: parseInt(rootGetters['config/rid']) === 0 ? parseInt(rootGetters['config/rid2']) : parseInt(rootGetters['config/rid'])
      })
      if (data.code === 1) {
        commit(types.FETCH_BANNERS, data.banners)
      } else {
        commit(types.SET_BANNER_MSG, 'banner')
      }
    } catch (e) {
      commit(types.SET_BANNER_MSG, 'banner')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/banner.js